import styled from 'styled-components';

export const ItemQuarter = styled.div`
  background-color: ${(props) => props?.color || 'unset'};
`;
export const TableChartWrapper = styled.div`
  margin-top: 40px;
  width: 100%;
  .border-right-none {
    border-right: none !important;
  }
  .border-top-none {
    border-top: none !important;
  }
  .margin-top-2 {
    margin-top: 2px;
  }
  .title-content {
    color: #00a8ff;
    font-weight: 700;
  }
  .padding-left-30 {
  }
  .background-color {
    background-color: #00a8ff;
    color: white;
  }
  .warning {
    color: tomato;
    text-decoration: underline;
  }
  .header-chart {
    display: flex;
    flex-direction: row;
    border: 1px solid #000;
    .header-index {
      padding: 4px 4px;
      width: 7%;
      text-align: center;
      border-right: 1px solid #000;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .criteria {
      padding: 4px 4px;
      width: 53%;
      border-right: 1px solid #000;
      font-weight: 500;
    }
    .quarter {
      padding: 4px 0;
      width: 10%;
      border-right: 1px solid #000;
      text-align: center;
      font-weight: 500;
      font-size: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
